<template>
    <div class="modal-tip">
        <div class="tip-close">
            <button v-on:click="modalsSetShow(null)">
                <svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0005 1.22222L9.77827 0L5.50019 4.27808L1.22222 0.000111474L0 1.22233L4.27797 5.5003L0.000501987 9.77776L1.22272 11L5.50019 6.72252L9.77776 11.0001L11 9.77788L6.72241 5.5003L11.0005 1.22222Z" />
                </svg>
                CLOSE
            </button>
        </div>
        <div class="tip-content">
            <div class="content-title">SEND TIP</div>
            <div class="content-info">
                <div class="info-user">You are about to tip <span v-html="modalsData.user.username" class="info-username" v-bind:class="[ 'username-' + modalsData.user.rank ]"></span>!</div>
                Please note that all tipped balance must be wagered before it is withdrawn.
            </div>
            <div class="content-input">
                <img src="@/assets/img/icons/coin.png" alt="coins-image" class="input-icon" />
                <input v-model="modalAmount" v-on:input="modalAmount = generalFormatInputAmount(modalAmount)" type="text" value="0.00" />
                <AvatarImage v-bind:image="modalsData.user.avatar" />
            </div>
            <div class="content-button">
                <button v-on:click="modalTipButton" class="button-tip" v-bind:disabled="socketSendLoading !== null">
                    <transition name="fade" mode="out-in">
                        <div class="button-loading" v-if="socketSendLoading === 'ChatTip'" key="loading">
                            <LoadingAnimation />
                        </div>
                        <div class="button-content" v-else key="content">SEND TIP</div>
                    </transition>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import mixins from '@/mixins';
    import { mapGetters, mapActions } from 'vuex';
    import AvatarImage from '@/components/AvatarImage';
    import LoadingAnimation from '@/components/LoadingAnimation';

    export default {
        name: 'ModalTip',
        components: {
            AvatarImage,
            LoadingAnimation
        },
        mixins: [
            mixins
        ],
        data() {
            return {
                modalAmount: '0.00'
            }
        },
        methods: {
            ...mapActions([
                'modalsSetShow', 
                'notificationShow', 
                'chatSendTipSocket'
            ]),
            modalTipButton() {
                if(isNaN(this.modalAmount) === true || Number(this.modalAmount) < 0.01) {
                    this.notificationShow({ type: 'error', message: 'Your entered tip amount is invalid.' });
                    return;
                }

                this.chatSendTipSocket({ receiverId: this.modalsData.user._id, amount: Math.floor(this.modalAmount * 1000) });
            }
        },
        computed: {
            ...mapGetters([
                'socketSendLoading',
                'authUser', 
                'modalsData'
            ])
        }
    }
</script>

<style scoped>
    .modal-tip {
        width: 620px;
        position: relative;
        display: flex;
        justify-content: center;
        padding: 25px 0 44px 0;
        border-radius: 18px;
        background: linear-gradient(180deg, #1A1E29 0%, #1C202C 100%);
        border-top: 32px solid #1e212e;
        border-bottom: 32px solid #1e212e;
    }

    .modal-tip .tip-close {
        position: absolute;
        top: -14px;
        right: 12px;
    }

    .modal-tip .tip-close button {
        height: 27px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 700;
        color: #767c8b;
        background: #212732;
    }

    .modal-tip .tip-close button:hover {
        color: #ffffff;
    }

    .modal-tip .tip-close button svg {
        margin-right: 8px;
        fill: #767c8b;
        transition: all 0.3s ease;
    }

    .modal-tip .tip-close button:hover svg {
        fill: #ffffff;
    }

    .modal-tip .tip-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .modal-tip .content-title {
        text-transform: uppercase;
        font-size: 26px;
        font-weight: 800;
        color: #323743;
    }

    .modal-tip .content-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 7px;
        font-size: 12px;
        font-weight: 700;
        color: #767c8b;
    }

    .modal-tip .info-user {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
    }

    .modal-tip .info-user span.info-username {
        margin-left: 5px;
        font-size: 14px;
        font-weight: 700;
    }

    .modal-tip .info-user span.info-username {
        color: #bbbbbb;
    }

    .modal-tip .info-user span.info-username.username-mod {
        color: #00c74d;
    }

    .modal-tip .info-user span.info-username.username-admin {
        color: #fd3b31;
    }

    .modal-tip .content-input {
        width: 370px;
        position: relative;
        margin-top: 25px;
    }

    .modal-tip .content-input input {
        width: 100%;
        height: 54px;
        padding: 0 60px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        color: #ffffff;
        background: #191e27;
        border: 1px solid #262c3a;
    }

    .modal-tip .content-input input::placeholder {
        font-size: 13px;
        font-weight: 700;
        color: #596076;
    }

    .modal-tip .content-input img.input-icon {
        width: 24px;
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translate(0, -50%);
    }

    .modal-tip .content-input .avatar-image {
        width: 33px;
        height: 33px;
        position: absolute;
        top: 50%;
        right: 11px;
        transform: translate(0, -50%);
        border-radius: 5px;
    }

    .modal-tip .content-button {
        width: 370px;
        margin-top: 18px;
    }

    .modal-tip .content-button button.button-tip {
        width: 100%;
        height: 55px;
        border-radius: 5px;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
        background: #00c74d;
        border-bottom: 2px solid #00732c;
    }

    .modal-tip .content-button button.button-tip:hover {
        background: #00de56;
    }

    .modal-tip .content-button button.button-tip.button-loading {
        background: #00c74d;
        cursor: not-allowed;
    }

    .modal-tip .content-button button.button-tip .button-loading {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-tip .content-button button.button-tip .button-loading svg {
        font-size: 16px;
    }

    .modal-tip .content-button button.button-tip .button-loading.fade-leave-active {
        transition: opacity 0.5s;
    }

    .modal-tip .content-button button.button-tip .button-loading.fade-leave-to {
        opacity: 0;
    }

    .modal-tip .content-button button.button-tip .button-content.fade-enter-active {
        transition: opacity 0.5s;
    }

    .modal-tip .content-button button.button-tip .button-content.fade-enter-from {
        opacity: 0;
    }

    @media only screen and (max-width: 650px) {

        .modal-tip {
            width: calc(100vw - 20px);
        }

    }

    @media only screen and (max-width: 450px) {

        .modal-tip .tip-content {
            padding: 0 20px;
        }

        .modal-tip .content-input {
            width: 100%;
        }

        .modal-tip .content-button {
            width: 100%;
        }

    }
</style>
